type IconProps = {
    icon: string;
    style?: React.CSSProperties;
    click?: () => void;
}

const iconStyle: React.CSSProperties = {
    // fontSize: ".6rem",
}

const FontIcon: React.FC<IconProps> = (props) => {
    const {icon, style = {}, click} = props;
    const mergeStyle = Object.assign({}, iconStyle, style);

    return (
        <span className={`s-icon ${icon}`} style={{...mergeStyle}} onClick={click}></span>
    )
}

export default FontIcon;
